import CrmPipelineSettingsAPI from '../../api/saas/crmPipelineSettings';

const state = {
  record: null,
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

const getters = {
  getSettings($state) {
    return $state.record;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }) {
    commit('SET_CRM_PIPELINE_SETTINGS_UI_FLAG', { isFetching: true });
    try {
      const response = await CrmPipelineSettingsAPI.get();
      commit('SET_CRM_PIPELINE_SETTINGS', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_PIPELINE_SETTINGS_UI_FLAG', { isFetching: false });
    }
  },
  async update({ commit }, data) {
    commit('SET_CRM_PIPELINE_SETTINGS_UI_FLAG', { isUpdating: true });
    try {
      const response = await CrmPipelineSettingsAPI.update(data);
      commit('SET_CRM_PIPELINE_SETTINGS', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_PIPELINE_SETTINGS_UI_FLAG', { isUpdating: false });
    }
  },
};

const mutations = {
  SET_CRM_PIPELINE_SETTINGS_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_CRM_PIPELINE_SETTINGS($state, data) {
    $state.record = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
